import { brandOf } from "./domains";
import { listingKey } from "./reportCore";

// Is this name or website the pinned advertiser? For highlighting the pinned
// advertiser on any report page (PPC today; the other channel pages later).
// Websites are compared by registrable domain, so "bookings.x.co.uk" matches
// a pin of "x.co.uk". A pin on a listing with no website ("name:...")
// matches that listing's name.
export function isPinnedAdvertiser(nameOrWebsite, pinKey) {
  if (!pinKey || !nameOrWebsite) return false;
  if (pinKey.startsWith("name:")) return listingKey(nameOrWebsite) === pinKey;
  return brandOf(nameOrWebsite) === pinKey;
}

// Is this name or website one of the highlighted advertisers (the yellow
// highlight from the Advertisers filter)? Same matching as the pin.
export function isHighlightedAdvertiser(nameOrWebsite, highlightKeys) {
  return (highlightKeys || []).some(key => isPinnedAdvertiser(nameOrWebsite, key));
}
